var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompressRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5671 7.02953L19.9105 0.769348L21.3154 2.19288L14.9916 8.43359L18.5615 8.44778L18.5535 10.4478L11.5536 10.4199L11.5814 3.41999L13.5814 3.42794L13.5671 7.02953Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97885 13.5429L3.40892 13.5457L3.40735 11.5457L10.4074 11.5402L10.4128 18.5402L8.41283 18.5418L8.41001 14.9403L2.09629 21.2307L0.684692 19.8138L6.97885 13.5429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressRight);
export default __webpack_public_path__ + "static/media/compressRight.822b3c2b9f7c665263e9205ffbb0a3c5.svg";
export { ForwardRef as ReactComponent };